import SendMessageUsingTemplateDrawer from '@shared/components/modals/send-message-using-template-drawer/send-message-using-template-drawer.vue';
import { SendMessageUsingTemplateModel, Template } from '@tools/interfaces/template';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import AbstractTable from './abstract-table';

@Component({
  components: {
    'bpc-send-message-using-template-drawer': SendMessageUsingTemplateDrawer,
  },
})
export default class SendMessageUsingTemplateMixin extends Vue {
  // DATA
  declare $refs: AbstractTable['$refs'];
  isSendingMessageUsingTemplate = false;
  declare entityName;
  showSendMessageUsingTemplateDrawer: boolean = false;
  sendMessageUsingTemplateErrors: Record<string, string[]> = null;
  contactsToSendMessageUsingTemplate: number[] = [];
  sendMessageUsingTemplateSelectedItemIds: number[] = [];
  sendMessageUsingTemplateAvailabilityContext: string = 'none';
  availableTemplatesForSendMessage: Template[] = [];
  defaultMessageType: string = 'message';
  defaultMessageTemplateId: number = null;
  showSendMessageUsingTemplateDrawerKey: number = 0;

  // LIFECYCLE
  mounted() {
    this.sendMessageUsingTemplateAvailabilityContext = this.$clientRouter.getContext();
  }

  // METHODS

  async getAllowedTemplatesForSendMessage() {
    const params = {
      entity: this.entityName,
      available_in: this.sendMessageUsingTemplateAvailabilityContext,
      type: 'email',
    };
    const templateRoute = this.$bpcApiRouteHelper.getEntityPath('template');
    const res = await this.$bpcApi.get(templateRoute, { params }).toPromise();
    this.availableTemplatesForSendMessage = res.data;
  }

  async onBulkSendMessageUsingTemplate(selection: number[]) {
    this.sendMessageUsingTemplateSelectedItemIds = selection;
    const selectedItems =
      this.$refs.provider.items.filter(item => selection.includes(item['id'])) || [];
    const contactIds = selectedItems.map(item => item['contact_id']);
    this.contactsToSendMessageUsingTemplate = contactIds.filter((item, pos) => {
      return contactIds.indexOf(item) === pos;
    });

    this.sendMessageUsingTemplateCleanErrors();
    this.openSendMessageUsingTemplateDrawer();
  }

  async onBulkSendMessageUsingTemplateToAttendees(selection: number[]) {
    this.sendMessageUsingTemplateSelectedItemIds = selection;
    const selectedItems =
      this.$refs.provider.items.filter(item => selection.includes(item['id'])) || [];
    const contactIds = selectedItems.map(item => item['attendee_id']);
    this.contactsToSendMessageUsingTemplate = contactIds.filter((item, pos) => {
      return contactIds.indexOf(item) === pos;
    });

    this.sendMessageUsingTemplateCleanErrors();
    this.openSendMessageUsingTemplateDrawer();
  }

  async onBulkSendMessageUsingTemplateToContacts(selection: number[]) {
    this.sendMessageUsingTemplateSelectedItemIds = selection;
    const selectedItems =
      this.$refs.provider.items.filter(item => selection.includes(item['id'])) || [];
    const contactIds = selectedItems.map(item => item['id']);
    this.contactsToSendMessageUsingTemplate = contactIds.filter((item, pos) => {
      return contactIds.indexOf(item) === pos;
    });

    this.sendMessageUsingTemplateCleanErrors();
    this.openSendMessageUsingTemplateDrawer();
  }

  async onSendMessageUsingTemplate(item) {
    this.contactsToSendMessageUsingTemplate = item?.contact_id ? [item.contact_id] : [];
    this.sendMessageUsingTemplateSelectedItemIds = item?.id ? [item?.id] : [];
    this.sendMessageUsingTemplateCleanErrors();
    this.openSendMessageUsingTemplateDrawer();
  }

  async onSendMessageUsingTemplateToAttendee(item) {
    this.contactsToSendMessageUsingTemplate = item?.attendee_id ? [item.attendee_id] : [];
    this.sendMessageUsingTemplateSelectedItemIds = item?.id ? [item?.id] : [];
    this.sendMessageUsingTemplateCleanErrors();
    this.openSendMessageUsingTemplateDrawer();
  }

  async onSendMessageUsingTemplateToContact(item) {
    this.contactsToSendMessageUsingTemplate = item?.id ? [item.id] : [];
    this.sendMessageUsingTemplateSelectedItemIds = item?.id ? [item?.id] : [];
    this.sendMessageUsingTemplateCleanErrors();
    this.openSendMessageUsingTemplateDrawer();
  }

  openSendMessageUsingTemplateDrawer() {
    this.showSendMessageUsingTemplateDrawer = true;
  }
  async closeSendMessageUsingTemplateDrawer() {
    this.isSendingMessageUsingTemplate = false;
    this.showSendMessageUsingTemplateDrawer = false;
    this.contactsToSendMessageUsingTemplate = [];
    this.sendMessageUsingTemplateCleanErrors();
  }

  async onConfirmSendMessageUsingTemplate(formModel: SendMessageUsingTemplateModel) {
    this.isSendingMessageUsingTemplate = true;
    try {
      await this.sendMessageUsingTemplate(formModel);
      this.extendedActionsAfterSendMessage();
      this.closeSendMessageUsingTemplateDrawer();
    } catch (error) {
      const errors = error?.response?.data?.errors;
      this.sendMessageUsingTemplateErrors = errors;
      this.isSendingMessageUsingTemplate = false;
    }
  }

  extendedActionsAfterSendMessage() {
    return null;
  }

  sendMessageUsingTemplateCleanErrors() {
    this.sendMessageUsingTemplateErrors = {};
  }

  async sendMessageUsingTemplate(formModel: SendMessageUsingTemplateModel) {
    const path = `${this.$bpcApiRouteHelper.getEntityPath('message')}`;
    return await this.$bpcApi.post(path, formModel).toPromise();
  }
}
